import { ResponsiveLayout } from "../../components/layout/ResponsiveLayout";
import { FavoritePlacesList } from "@/components/places";

export default function FavoritePlacesPage() {
  return (
    <ResponsiveLayout
      showNavbar={false}
      showBottomNav={true}
      backgroundColor="#FBF6F1"
      fullHeight={true}
      centered={true}
      maxWidth="md"
    >
      <FavoritePlacesList />
    </ResponsiveLayout>
  );
}
